import request from "../../utils/request";
import moment from "moment";
import { cacheTime } from "../../utils/constant";
import cssVars from "css-vars-ponyfill";
import less from "less";
import lodash from "lodash";

const baseUrl = "/api/server";

export default {
    namespaced: true,
    state: {
        info: null,
        cacheDate: {
            info: null
        }
    },
    getters: {},
    actions: {
        getInfo(context, { config = {}, options = {} }) {
            options = {
                cache: true,
                force: false,
                ...options
            };
            if (context.state.cacheDate.info && context.state.cacheDate.info.isBefore(moment())) {
                options.force = true;
            }
            const info = context.state.info;
            if (info && !options.force) {
                return new Promise(reslove => reslove(info));
            }
            return request.get(`${baseUrl}/info`, { ...config }).then(info => {
                context.commit("setInfo", info);
                return info;
            });
        }
    },
    mutations: {
        setInfo(state, info) {
            state.info = info;
            state.cacheDate.info = moment().add(cacheTime, "ms");

            if (info.favicon) {
                let link = document.querySelector("link[rel*='icon']");
                link.href = `${process.env.VUE_APP_API_URL}${info.favicon}?timestamp=${new Date().getTime()}`;
                document.getElementsByTagName("head")[0].appendChild(link);
            }
            if (info.lessVar) {
                less.modifyVars(info.lessVar);
                less.refreshStyles();
                let cssVar = lodash.mapKeys(info.lessVar, (value, key) => key.replace("@", "--"));
                cssVar = lodash.mapValues(cssVar, value => (value.startsWith("@") ? info.lessVar[value] : value));
                cssVars({ variables: cssVar });

                // for fix first load no cache
                setTimeout(() => {
                    less.modifyVars(info.lessVar);
                    less.refreshStyles();
                    let cssVar = lodash.mapKeys(info.lessVar, (value, key) => key.replace("@", "--"));
                    cssVar = lodash.mapValues(cssVar, value => (value.startsWith("@") ? info.lessVar[value] : value));
                    cssVars({ variables: cssVar });
                }, 2000);
            }
        }
    }
};
